// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__qCJE6","link":"style_link__11auC","error":"style_error__2BUV0"};